import "./DigestRoomButton.css";

export const DigestRoomButton = () => {
    return (
        <a className="header__logo-button" href="/" >D</a>
    );
}
